import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import React from "react";
import { batchHistoricalEventsStyles } from "./BatchHistoricalEventsStyles";
import { pluralize } from "helpers/pluralize";
import { BatchHistoryEntry } from "models/thorEventModels/BatchHistoryEntry";
import { numberAfterDotCounter } from "helpers/numberAfterDotCounter";
import { EventType } from "models/thorEventModels/ActiveEvents";
import moment from "moment";

export interface BatchHistoryProps {
    history: BatchHistoryEntry[];
}

export default observer(function BatchHistoricalEvents({ history }: BatchHistoryProps) {
    const classes = batchHistoricalEventsStyles();
    function openInNewTab(url: string) {
        window.open(url, "_blank")!.focus();
    }
    const headers = [
        "Event Id",
        "Event Creation Date",
        "Impact Decision",
        "Type of Event",
        "Temp Range of Excursion",
        "Cumulative Excursion Time",
        "Returned to Stock",
    ];

    return (
        <div className={classes.main}>
            <Typography variant="h4">Batch Historical Events</Typography>
            {history.length === 0 ? (
                <Typography>No previous events</Typography>
            ) : (
                <>
                    {" "}
                    <Typography className={classes.subTitle}>
                        {history.length} previous {pluralize("event", history.length)}
                    </Typography>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {headers.map((header) => (
                                    <TableCell key={header} className={classes.headerCell}>
                                        <Typography className={classes.headerTitle}>{header}</Typography>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {history.map((data) => (
                                <TableRow key={data.eventId}>
                                    <TableCell>
                                        <Typography
                                            className={classes.Id}
                                            onClick={() => {
                                                openInNewTab(`/thor/eventDetails/${data.eventId}`);
                                            }}
                                        >
                                            {"TE" + data.eventId}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>
                                            {moment.utc(data.eventCreatedAt).format("DD MMM YYYY HH:mm:ss ")}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>
                                            {data.excursionIsSupported === null
                                                ? "Pending"
                                                : data.excursionIsSupported
                                                ? "Supported"
                                                : "Not Supported"}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>
                                            {Object.values(EventType)[Number.parseInt(data.eventType)]}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>
                                            {numberAfterDotCounter(data.rangeLowerLimit) +
                                                "°C to " +
                                                numberAfterDotCounter(data.rangeUpperLimit) +
                                                "°C"}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>
                                            {numberAfterDotCounter(data.durationInHours) +
                                                " " +
                                                pluralize("hour", numberAfterDotCounter(data.durationInHours))}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>
                                            {data.returnedToStock === null ? "-" : data.returnedToStock ? "Yes" : "No"}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </>
            )}
        </div>
    );
});
